/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 388);
/******/ })
/************************************************************************/
/******/ ({

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(389);
module.exports = __webpack_require__(390);


/***/ }),

/***/ 389:
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window$Liftoff = window.Liftoff,
    Component = _window$Liftoff.Component,
    DOMUtils = _window$Liftoff.DOMUtils,
    Utils = _window$Liftoff.Utils;


var MAXIMUM_STAR_RATING = 5;
var FILLED_STAR_CHAR = "&#9733;";
var EMPTY_STAR_CHAR = "&#9734;";

var TEMPLATE = "\n  <div class=\"product-tile-banner loading\">\n    <div class=\"icon switch-with-component\"></div>\n    <div class=\"text-container switch-with-component\">\n      <div class=\"app-name\"></div>\n      <div class=\"star-rating\">\n        <div class=\"empty-stars\">" + new Array(MAXIMUM_STAR_RATING).fill(EMPTY_STAR_CHAR).join("") + "</div>\n        <div class=\"filled-stars\">" + new Array(MAXIMUM_STAR_RATING).fill(FILLED_STAR_CHAR).join("") + "</div>\n      </div>\n      <div class=\"caption\"></div>\n    </div>\n    <div class=\"outer-cta-container switch-with-component\">\n      <div class=\"cta-container\"></div>\n    </div>\n    <div class=\"component-container exited\"></div>\n  </div>\n";

Component.register("product-tile-banner", function (_Component) {
  _inherits(ProductTileBanner, _Component);

  function ProductTileBanner(config) {
    _classCallCheck(this, ProductTileBanner);

    var _this = _possibleConstructorReturn(this, (ProductTileBanner.__proto__ || Object.getPrototypeOf(ProductTileBanner)).call(this, config));

    Object.assign(_this, Utils.mergePropertiesWithDefaults({
      icon: null,
      iconStyles: {},
      appName: "",
      appNameStyles: {},
      starRating: null,
      starStyles: {},
      caption: null,
      captionStyles: {},
      cta: null,
      ctaStyles: {},
      component: null,
      componentStyles: {},
      switchElements: "all",
      appInfoDuration: 1800,
      componentDuration: 2000,
      switchingDuration: 500,
      initialDelay: 1800,
      appNameLineLimit: null,
      forceFullscreenWidth: false
    }, config));
    _this.transitionEndHandler = function (e) {
      // We only want to listen to transition events coming from elements in this component (not any bubbling
      // events from child components). Within this component, "transform" and "visibility" properties are
      // both transitioned and both will independently produce transitionend events. But we only want to
      // respond to one transition per element regardless of the number of properties transitioned.
      if (e.propertyName !== "transform" || e.target !== e.currentTarget) return;
      _this.animateNext();
    };
    _this.ready = false;
    _this.startWhenReady = false;
    _this.firstAnimationComplete = false;
    _this.running = false;
    if (_this.starRating != null) {
      _this.starRating = Math.min(Math.max(0, _this.starRating), MAXIMUM_STAR_RATING);
    }
    return _this;
  }

  _createClass(ProductTileBanner, [{
    key: "load",
    value: function load() {
      var _this2 = this;

      var loadPromises = [this.component, this.caption, this.cta].filter(function (c) {
        return c;
      }).map(function (c) {
        return c.load();
      });
      if (this.icon != null) {
        var imageLoadPromise = Utils.loadImage(this.icon).then(function (imgEl) {
          return _this2.iconImgEl = imgEl;
        });
        loadPromises.push(imageLoadPromise);
      }

      this.loaded = Promise.all(loadPromises);
      return this.loaded;
    }
  }, {
    key: "layout",
    value: function layout(parentNode) {
      var _this3 = this;

      _get(ProductTileBanner.prototype.__proto__ || Object.getPrototypeOf(ProductTileBanner.prototype), "layout", this).call(this, parentNode);

      this.el = DOMUtils.strToElement(TEMPLATE);
      if (parentNode.getBoundingClientRect().height >= 80) {
        this.el.classList.add("tablet");
      }

      var captionEl = this.el.querySelector(".caption");
      Object.assign(captionEl.style, this.captionStyles);
      [].concat(_toConsumableArray(this.el.children)).forEach(function (childEl) {
        childEl.style.transitionDuration = _this3.switchingDuration + "ms";
      });

      this.parentNode.appendChild(this.el);
      this.loaded.then(function () {
        if (_this3.cta != null) {
          var ctaContainer = _this3.el.querySelector(".cta-container");
          Object.assign(ctaContainer.style, _this3.ctaStyles);
          _this3.cta.layout(ctaContainer);
        } else {
          _this3.el.querySelector(".outer-cta-container").remove();
        }

        if (_this3.starRating != null) {
          _this3.setStarRating();
          Object.assign(_this3.el.querySelector(".star-rating").style, _this3.starStyles);
        } else {
          _this3.el.querySelector(".star-rating").remove();
        }

        if (_this3.icon == null) {
          return Promise.resolve();
        }

        _this3.el.querySelector(".icon").appendChild(_this3.iconImgEl);
        Object.assign(_this3.iconImgEl.style, _this3.iconStyles);
        return DOMUtils.imageIsRendered(_this3.iconImgEl);
      }).then(function () {
        var appNameEl = _this3.el.querySelector(".app-name");
        Object.assign(appNameEl.style, _this3.appNameStyles);
        if (_this3.appNameLineLimit != null) {
          appNameEl.style.visiblity = "hidden";
          // We fill the element with a number of line breaks equal to the line limit to determine the height of
          // the element were the maximum number of lines to be used.
          var limitString = Array(_this3.appNameLineLimit).fill("<br>").join("");
          var conformsToLineLimit = function conformsToLineLimit() {
            appNameEl.innerHTML = limitString;
            var limitHeight = appNameEl.getBoundingClientRect().height;
            appNameEl.innerHTML = _this3.appName;
            var populatedHeight = appNameEl.getBoundingClientRect().height;
            // If the user specified a height via CSS, then populatedHeight will always === limitHeight.
            // In this case, we assume the user's intent is to make the text fit into the given height,
            // so we also check `scrollHeight`.
            return populatedHeight <= limitHeight && appNameEl.scrollHeight <= populatedHeight;
          };
          var fontSize = parseInt(window.getComputedStyle(appNameEl).fontSize);
          while (!conformsToLineLimit() && fontSize > 0) {
            fontSize -= 1;
            Object.assign(appNameEl.style, {
              fontSize: fontSize + "px",
              lineHeight: fontSize * 1.1 + "px"
            });
          }
          appNameEl.style.visbility = "visible";
        }
        appNameEl.innerHTML = _this3.appName;

        if (_this3.caption != null) {
          var captionContainerEl = _this3.el.querySelector(".caption");
          // NOTE(Casey): On Safari, without position: absolute on the caption
          // container during subcomponent layout, children with width: 100%,
          // height: 100% will be sized relative to the nearest positioned
          // ancestor, possibly resulting in a caption that extends beyond the
          // bounds of the component container. We reset the position after layout
          // to attain proper positioning relative to sibling elements.
          captionContainerEl.style.position = "absolute";
          _this3.caption.layout(_this3.el.querySelector(".caption"));
          captionContainerEl.style.height = captionContainerEl.getBoundingClientRect().height + "px";
          captionContainerEl.style.position = "relative";
        } else {
          _this3.el.querySelector(".caption").remove();
        }
      }).then(function () {
        if (_this3.component != null) {
          _this3.componentContainerEl = _this3.el.querySelector(".component-container");
          Object.assign(_this3.componentContainerEl.style, _this3.componentStyles);
          _this3.setComponentContainerSize();

          // Force component to take full screen width
          if (_this3.forceFullscreenWidth) {
            _this3.componentContainerEl.style.width = "100%";
            _this3.componentContainerEl.style.left = 0;

            // Increase z-index value for icon and cta containers so that they
            // appear as overlay on the component area
            _this3.el.querySelector(".outer-cta-container").style.zIndex = 2;
            _this3.el.querySelector(".icon").style.zIndex = 2;
          }

          _this3.component.layout(_this3.componentContainerEl);
          DOMUtils.addOneTimeListener(_this3.el, "transitionend", function () {
            _this3.firstAnimationComplete = true;
          });
        }

        _this3.ready = true;
        _this3.el.classList.remove("loading");
        if (_this3.startWhenReady) {
          _this3.start();
        }
      });
    }
  }, {
    key: "setComponentContainerSize",
    value: function setComponentContainerSize() {
      var left = 0;
      var right = 0;
      if (this.switchElements === "all but cta" && this.cta != null) {
        var ctaContainerEl = this.el.querySelector(".outer-cta-container");
        right = this.el.getBoundingClientRect().right - ctaContainerEl.getBoundingClientRect().left;
        ctaContainerEl.classList.remove("switch-with-component");
      } else if (this.switchElements === "all but icon" && this.icon != null) {
        DOMUtils.forceReflow(this.el.querySelector(".icon"));
        left = this.el.querySelector(".icon").getBoundingClientRect().width;
        this.el.querySelector(".icon").classList.remove("switch-with-component");
      }

      Object.assign(this.componentContainerEl.style, {
        right: right + "px",
        left: left + "px"
      });
    }
  }, {
    key: "setStarRating",
    value: function setStarRating() {
      var filledStarEl = this.el.querySelector(".filled-stars");
      var filledStarWidth = this.starRating / MAXIMUM_STAR_RATING * filledStarEl.getBoundingClientRect().width;
      // Flooring and subtracting 0.5 was determined empirically to produce a visualization that worked well
      // for all whole and half values.
      filledStarWidth = Math.max(Math.floor(filledStarWidth - 0.5), 0);
      filledStarEl.style.width = filledStarWidth + "px";
    }
  }, {
    key: "animateNext",
    value: function animateNext() {
      var _this4 = this;

      var switchingEls = [].concat(_toConsumableArray(this.el.querySelectorAll(".switch-with-component")));
      var enterEl = function enterEl(el) {
        el.classList.add("staged");
        el.classList.remove("exited");
        DOMUtils.forceReflow(el);
        el.classList.remove("staged");
      };
      var exitEl = function exitEl(el) {
        return el.classList.add("exited");
      };

      if (this.componentContainerEl.classList.contains("exited")) {
        // Animate component in.
        var animationDelay = this.firstAnimationComplete ? this.appInfoDuration : this.initialDelay;
        this.component.stop();
        this.animationTimeout = setTimeout(function () {
          switchingEls.forEach(exitEl);
          enterEl(_this4.componentContainerEl);
          _this4.component.start();
        }, animationDelay);
      } else {
        // Animate app info in.
        this.animationTimeout = setTimeout(function () {
          switchingEls.forEach(enterEl);
          exitEl(_this4.componentContainerEl);
        }, this.componentDuration);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      if (this.component == null) return;
      this.setComponentContainerSize();
      this.component.resize();
      this.setStarRating();
    }
  }, {
    key: "restart",
    value: function restart() {
      this.stop();
      this.firstAnimationComplete = false;
      this.start();
    }
  }, {
    key: "start",
    value: function start() {
      this.startWhenReady = true;
      if (!this.ready || this.running) return;
      if (this.cta != null) {
        this.cta.start();
      }
      if (this.caption != null) {
        this.caption.start();
      }

      if (this.component == null) return;
      this.running = true;
      this.componentContainerEl.addEventListener("transitionend", this.transitionEndHandler);
      this.animateNext();
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this5 = this;

      this.startWhenReady = false;
      if (!this.running) return;
      if (this.cta != null) {
        this.cta.stop();
      }
      if (this.caption != null) {
        this.caption.stop();
      }

      if (this.component == null) return;
      clearTimeout(this.animationTimeout);
      this.componentContainerEl.removeEventListener("transitionend", this.transitionEndHandler);
      this.running = false;
      [].concat(_toConsumableArray(this.el.children)).forEach(function (childEl) {
        // Stop the current transition by setting transition: none, and then reset the style.
        childEl.style.transition = "none";
        DOMUtils.forceReflow(childEl);
        // When the component stops, make sure the app info (rather than the component) is displayed.
        childEl.classList.remove("staged");
        if (childEl === _this5.componentContainerEl) {
          childEl.classList.add("exited");
        } else {
          childEl.classList.remove("exited");
        }

        DOMUtils.forceReflow(childEl);
        childEl.style.transition = null;
      });
      this.component.stop();
    }
  }]);

  return ProductTileBanner;
}(Component));

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// product-tile-banner-38f2119635ae7e54fb36.js